import { useCallback } from "react";

import type { Plan } from "@/lib/gql/__generated__/graphql";

import type { DnDResultItem } from "@/hooks/use-dnd/use-dnd";

import { TableRow } from "@/components/ui/table/table";

import { PlanListPageTableItem } from "./item";

type Props = {
	plan: DnDResultItem<Plan>;
	editPlanPagePath: string;
	onTransitionToEdit: () => void;
	onDeletePlan: () => Promise<void>;

	isSorting: boolean;
	showScConnectedColumn: boolean;
};

export const PlanListPageTableSortableItem = ({
	plan,
	editPlanPagePath,
	onTransitionToEdit,
	onDeletePlan,
	isSorting,
	showScConnectedColumn,
}: Props) => {
	const { value } = plan;

	const handleClick = useCallback(() => {
		if (isSorting) return;
		onTransitionToEdit();
	}, [isSorting, onTransitionToEdit]);

	return (
		<TableRow
			key={plan.key}
			className="select-none hover:cursor-pointer"
			ref={isSorting ? plan.events.ref : undefined}
			onMouseDown={isSorting ? plan.events.onMouseDown : undefined}
			onClick={handleClick}
		>
			<PlanListPageTableItem
				editPlanPagePath={editPlanPagePath}
				onDeletePlan={onDeletePlan}
				onTransitionToEdit={onTransitionToEdit}
				plan={value}
				isSorting={isSorting}
				showScConnectedColumn={showScConnectedColumn}
			/>
		</TableRow>
	);
};

PlanListPageTableSortableItem.displayName = "PlanListPageTableSortableItem";
